// For full API documentation, including code examples, visit http://wix.to/94BuAAs
// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

import {session} from 'wix-storage';
import wixLocation from 'wix-location';

let previousPageURL;

$w.onReady(function () {

	previousPageURL = session.getItem("page"); 
	console.log(previousPageURL);
	session.setItem("page", wixLocation.url);
	$w("#backbtn").link = previousPageURL;
	$w("#backbtn").target = "_self";
});
